import styled from 'styled-components';

export const HelperText = styled.div`
  color: #8f8f8f;
  font-size: 0.8rem;
`;
